import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledNoDataBlock = styled(FlexColumn)`
    height: calc(100% - 36px);
    justify-content: center;
    align-items: center;
`;

export const StyledImageWrapper = styled.div`
    display: flex;
    width: 125px;
    margin-bottom: 16px;
`;

export const StyledNoSelectedTopicHeader = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
`;

export const StyledNoSelectedTopicDescription = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};
`;
